// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tthti758XvwIoMFSllpE{flex-direction:column;display:flex}.tthti758XvwIoMFSllpE .H3nmLrCg0M7WxiXztdPX{flex-direction:column;gap:4px;width:100%;max-width:432px;display:flex}.tthti758XvwIoMFSllpE .z7Lm2RrB6Q9UP4XMAWQc{gap:12px;width:100%;margin-top:16px;display:flex}.tthti758XvwIoMFSllpE .FBInp7CdJvg4VlBQxqWu{cursor:pointer;height:40px;padding:12px 8px 8px 14px}.tthti758XvwIoMFSllpE .FBInp7CdJvg4VlBQxqWu:hover{background-color:transparent!important}.tthti758XvwIoMFSllpE .gbxIyz_RzZI6YBpSnjlB{color:var(--content-neutral-primary)}.tthti758XvwIoMFSllpE .WNGJZtG1y8E9nUKWqeik{height:40px;padding:12px 8px 8px}.SjoNU0Fs99Mu0hJgddbs{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `tthti758XvwIoMFSllpE`,
	"inputWrap": `H3nmLrCg0M7WxiXztdPX`,
	"inputs": `z7Lm2RrB6Q9UP4XMAWQc`,
	"inputDatePicker": `FBInp7CdJvg4VlBQxqWu`,
	"datePickerIcon": `gbxIyz_RzZI6YBpSnjlB`,
	"inputTimePicker": `WNGJZtG1y8E9nUKWqeik`,
	"actions": `SjoNU0Fs99Mu0hJgddbs`
};
export default ___CSS_LOADER_EXPORT___;
